import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const QrModalStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      maxWidth: "450px",
      position: "fixed",
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
    },
    blured: {
      filter: "blur(4px)",
    },
    notBlured: {
      filter: "none",
    },
    instructions: {
      position: "fixed",
      top: "10%",
      zIndex: 100,
      textAlign: "center",
      paddingTop: "44px",
      paddingBottom: "39px",
      boxShadow: "none",
      background: "#ffffffd6",
      left: 0,
      [theme.breakpoints.down("md")]: {
        top: "8%",
        paddingTop: 60,
        paddingBottom: 60,
      },
      [theme.breakpoints.down("sm")]: {
        top: "8%",
        paddingTop: 80,
        paddingBottom: 110,
      },
    },
    hide: {
      display: "none",
    },
    fieldTitle: {
      fontSize: "16px",
      paddingBottom: "5px",
      fontWeight: 600,
      color: "rgba(24,32,57,.5)",
    },
    memoModalContainer: {},
    innerContainer: {},
    qrContainer: {},
    addressContainer: {
      width: "230px",
      wordBreak: "break-all",
    },
    addressCode: {
      fontSize: 20,
      fontWeight: theme.typography.fontWeightMedium,
    },
    copyAddressContainer: {
      height: "70px",
    },
    copy: {
      width: "400px",
      position: "relative !important" as "relative",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      bgcolor: "background.paper",
      borderRadius: "10px",
      overflowY: "auto",
      overflowX: "hidden",
      zIndex: 200,
    },
    headerContainer: {
      borderRadius: "12px",
    },
    header: {
      height: 90,
      backgroundColor: "#5470DE",
      borderRadius: "12px 12px 0px 0px",
    },
    titleContainer: {
      [theme.breakpoints.up("md")]: {
        paddingLeft: "10%",
      },
    },
    iconItem: {
      paddingRight: 10,
    },
    title: {
      color: "#fff",
      fontSize: "24px",
      "@media (max-width:400px)": {
        fontSize: "18px",
      },
    },
    memoStyling: {
      color: "rgba(24,32,57,.5)",
      fontWeight: 600,
      height: "auto",

      "& .MuiOutlinedInput-input": {
        textAlign: "center",
      },

      "&.Mui-focused": {
        // border: ".5px solid rgba(24,32,57,.3)",
        "& .MuiOutlinedInput-notchedOutline": {
          border: "1px solid rgba(24,32,57,.3)",
        },
      },
    },
  }),
);
